import { SafeResourceUrl } from '@angular/platform-browser';
import { DocumentDescriptionDTO } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';
import { DocumentDescriptionWithUrl } from '../reducer/document.reducer';

export enum DocumentActionTypes {
    LoadDocument = '[Document] Load Document',
    LoadDocumentSuccess = '[Document] Load Document Success',
    LoadDocumentFailure = '[Document] Load Document Failure',

    DownloadDocument = '[Document] DownloadDocument',

    LoadCompanyLogo = '[Document] Load Company Logo',
    LoadCompanyLogoSuccess = '[Document] Load Company Logo Success',
    LoadCompanyLogoFailure = '[Document] Load Company Logo Failure',

    LoadCompanyLogoExtra = '[Document] Load Company Logo Extra',
    LoadCompanyLogoExtraSuccess = '[Document] Load Company Logo Extra Success',
    LoadCompanyLogoExtraFailure = '[Document] Load Company Logo Extra Failure',

    DeleteCompanyLogo = '[Document] DeleteCompanyLogo',
    DeleteCompanyLogoSuccess = '[Document] DeleteCompanyLogoSuccess',
    DeleteCompanyLogoFailure = '[Document] DeleteCompanyLogoFailure',

    DeleteCompanyLogoExtra = '[Document] DeleteCompanyLogoExtra',
    DeleteCompanyLogoExtraSuccess = '[Document] DeleteCompanyLogoExtraSuccess',
    DeleteCompanyLogoExtraFailure = '[Document] DeleteCompanyLogoFailureExtra',

    LoadHealthInsurerLogo = '[Document] Load Health Insurer Logo',
    LoadHealthInsurerLogoSuccess = '[Document] Load Health Insurer Logo Success',
    LoadHealthInsurerLogoFailure = '[Document] Load Health Insurer Logo Failure',

    UploadCompanyLogo = '[Document] Upload Company Logo',
    UploadCompanyLogoFailure = '[Document] Upload Company Logo Failure',
    UploadCompanyLogoSuccess = '[Document] Upload Company Logo Success',

    UploadCompanyLogoExtra = '[Document] Upload Company Logo Extra',
    UploadCompanyLogoExtraFailure = '[Document] Upload Company Logo Extra Failure',
    UploadCompanyLogoExtraSuccess = '[Document] Upload Company Logo Extra Success',

    UploadHealthInsurerLogo = '[Document] Upload Health Insurer Logo',
    UploadHealthInsurerLogoFailure = '[Document] Upload Health Insurer Logo Failure',

    DeleteHealthInsurerLogo = '[Document] DeleteHealthInsurerLogo',
    DeleteHealthInsurerLogoSuccess = '[Document] DeleteHealthInsurerLogoSuccess',
    DeleteHealthInsurerLogoFailure = '[Document] DeleteHealthInsurerLogoFailure',

    DownloadHealthInsurerLogo = '[Document] Download Health Insurer Logo',

    LoadProfilePicture = '[Document] Load Profile Picture',
    LoadProfilePictureSuccess = '[Document] Load Profile Picture Success',
    LoadProfilePictureFailure = '[Document] Load Profile Picture Failure',

    LoadCentralRegulatorLogo = '[Document] Load CentralRegulator Logo',
    LoadCentralRegulatorLogoSuccess = '[Document] Load CentralRegulator Logo Success',
    LoadCentralRegulatorLogoFailure = '[Document] Load CentralRegulator Logo Failure',

    LoadCentralRegulatorLogoExtra = '[Document] Load CentralRegulator Logo Extra',
    LoadCentralRegulatorLogoExtraSuccess = '[Document] Load CentralRegulator Logo Extra Success',
    LoadCentralRegulatorLogoExtraFailure = '[Document] Load CentralRegulator Logo Extra Failure',

    DeleteCentralRegulatorLogo = '[Document] DeleteCentralRegulatorLogo',
    DeleteCentralRegulatorLogoSuccess = '[Document] DeleteCentralRegulatorLogoSuccess',
    DeleteCentralRegulatorLogoFailure = '[Document] DeleteCentralRegulatorLogoFailure',

    DeleteCentralRegulatorLogoExtra = '[Document] DeleteCentralRegulatorLogoExtra',
    DeleteCentralRegulatorLogoExtraSuccess = '[Document] DeleteCentralRegulatorLogoExtraSuccess',
    DeleteCentralRegulatorLogoExtraFailure = '[Document] DeleteCentralRegulatorLogoFailureExtra',

    UploadCentralRegulatorLogo = '[Document] Upload CentralRegulator Logo',
    UploadCentralRegulatorLogoFailure = '[Document] Upload CentralRegulator Logo Failure',
    UploadCentralRegulatorLogoSuccess = '[Document] Upload CentralRegulator Logo Success',

    UploadCentralRegulatorLogoExtra = '[Document] Upload CentralRegulator Logo Extra',
    UploadCentralRegulatorLogoExtraFailure = '[Document] Upload CentralRegulator Logo Extra Failure',
    UploadCentralRegulatorLogoExtraSuccess = '[Document] Upload CentralRegulator Logo Extra Success'
}
export const DeleteCompanyLogo = createAction(DocumentActionTypes.DeleteCompanyLogo, props<{ companyId: string }>());
export const DeleteCompanyLogoSuccess = createAction(DocumentActionTypes.DeleteCompanyLogoSuccess, props<{ companyId: string }>());
export const DeleteCompanyLogoFailure = createAction(DocumentActionTypes.DeleteCompanyLogoFailure, props<{ error: any }>());
export const DeleteCompanyLogoExtra = createAction(DocumentActionTypes.DeleteCompanyLogoExtra, props<{ companyId: string }>());
export const DeleteCompanyLogoExtraSuccess = createAction(
    DocumentActionTypes.DeleteCompanyLogoExtraSuccess,
    props<{ companyId: string }>()
);
export const DeleteCompanyLogoExtraFailure = createAction(DocumentActionTypes.DeleteCompanyLogoExtraFailure, props<{ error: any }>());

export const LoadDocument = createAction(DocumentActionTypes.LoadDocument, props<{ document: DocumentDescriptionWithUrl }>());
export const LoadDocumentSuccess = createAction(DocumentActionTypes.LoadDocumentSuccess, props<{ document: DocumentDescriptionWithUrl }>());
export const LoadDocumentFailure = createAction(DocumentActionTypes.LoadDocumentFailure, props<{ error: any }>());
export const DownloadDocument = createAction(DocumentActionTypes.DownloadDocument, props<{ document: DocumentDescriptionDTO }>());

export const LoadCompanyLogo = createAction(DocumentActionTypes.LoadCompanyLogo, props<{ companyId: string }>());
export const LoadCompanyLogoSuccess = createAction(
    DocumentActionTypes.LoadCompanyLogoSuccess,
    props<{ companyLogoUrl: SafeResourceUrl; companyId: string }>()
);
export const LoadCompanyLogoFailure = createAction(DocumentActionTypes.LoadCompanyLogoFailure, props<{ companyId: string; error: any }>());

export const LoadCompanyLogoExtra = createAction(DocumentActionTypes.LoadCompanyLogoExtra, props<{ companyId: string }>());
export const LoadCompanyLogoExtraSuccess = createAction(
    DocumentActionTypes.LoadCompanyLogoExtraSuccess,
    props<{ companyLogoExtraUrl: SafeResourceUrl; companyId: string }>()
);
export const LoadCompanyLogoExtraFailure = createAction(
    DocumentActionTypes.LoadCompanyLogoExtraFailure,
    props<{ companyId: string; error: any }>()
);

export const UploadCompanyLogo = createAction(DocumentActionTypes.UploadCompanyLogo, props<{ companyId: string; file: File }>());
export const UploadCompanyLogoFailure = createAction(DocumentActionTypes.UploadCompanyLogoFailure, props<{ error: any }>());
export const UploadCompanyLogoSuccess = createAction(
    DocumentActionTypes.UploadCompanyLogoSuccess,
    props<{ companyLogoUrl: SafeResourceUrl; companyId: string }>()
);

export const UploadCompanyLogoExtra = createAction(DocumentActionTypes.UploadCompanyLogoExtra, props<{ companyId: string; file: File }>());
export const UploadCompanyLogoExtraFailure = createAction(DocumentActionTypes.UploadCompanyLogoExtraFailure, props<{ error: any }>());
export const UploadCompanyLogoExtraSuccess = createAction(
    DocumentActionTypes.UploadCompanyLogoExtraSuccess,
    props<{ companyLogoExtraUrl: SafeResourceUrl; companyId: string }>()
);

export const LoadHealthInsurerLogo = createAction(DocumentActionTypes.LoadHealthInsurerLogo, props<{ healthInsurerId: string }>());
export const LoadHealthInsurerLogoSuccess = createAction(
    DocumentActionTypes.LoadHealthInsurerLogoSuccess,
    props<{ healthInsurerLogoUrl: SafeResourceUrl; healthInsurerId: string }>()
);
export const LoadHealthInsurerLogoFailure = createAction(
    DocumentActionTypes.LoadHealthInsurerLogoFailure,
    props<{ healthInsurerId: string; error: any }>()
);

export const UploadHealthInsurerLogo = createAction(
    DocumentActionTypes.UploadHealthInsurerLogo,
    props<{ healthInsurerId: string; file: File }>()
);
export const UploadHealthInsurerLogoFailure = createAction(DocumentActionTypes.UploadHealthInsurerLogoFailure, props<{ error: any }>());
export const DeleteHealthInsurerLogo = createAction(DocumentActionTypes.DeleteHealthInsurerLogo, props<{ healthInsurerId: string }>());
export const DeleteHealthInsurerLogoSuccess = createAction(
    DocumentActionTypes.DeleteHealthInsurerLogoSuccess,
    props<{ healthInsurerId: string }>()
);
export const DeleteHealthInsurerLogoFailure = createAction(DocumentActionTypes.DeleteHealthInsurerLogoFailure, props<{ error: any }>());
export const DownloadHealthInsurerLogo = createAction(
    DocumentActionTypes.DownloadHealthInsurerLogo,
    props<{ healthInsurerId: string; fileName: string }>()
);

export const LoadProfilePicture = createAction(DocumentActionTypes.LoadProfilePicture, props<{ employeeId: string }>());
export const LoadProfilePictureSuccess = createAction(
    DocumentActionTypes.LoadProfilePictureSuccess,
    props<{ employeeId: string; profilePictureUrl: SafeResourceUrl }>()
);
export const LoadProfilePictureFailure = createAction(
    DocumentActionTypes.LoadProfilePictureFailure,
    props<{ employeeId: string; error: any }>()
);

// central regulator
export const DeleteCentralRegulatorLogo = createAction(
    DocumentActionTypes.DeleteCentralRegulatorLogo,
    props<{ centralRegulatorId: string }>()
);
export const DeleteCentralRegulatorLogoSuccess = createAction(
    DocumentActionTypes.DeleteCentralRegulatorLogoSuccess,
    props<{ centralRegulatorId: string }>()
);
export const DeleteCentralRegulatorLogoFailure = createAction(
    DocumentActionTypes.DeleteCentralRegulatorLogoFailure,
    props<{ error: any }>()
);
export const DeleteCentralRegulatorLogoExtra = createAction(
    DocumentActionTypes.DeleteCentralRegulatorLogoExtra,
    props<{ centralRegulatorId: string }>()
);
export const DeleteCentralRegulatorLogoExtraSuccess = createAction(
    DocumentActionTypes.DeleteCentralRegulatorLogoExtraSuccess,
    props<{ centralRegulatorId: string }>()
);
export const DeleteCentralRegulatorLogoExtraFailure = createAction(
    DocumentActionTypes.DeleteCentralRegulatorLogoExtraFailure,
    props<{ error: any }>()
);

export const LoadCentralRegulatorLogo = createAction(DocumentActionTypes.LoadCentralRegulatorLogo, props<{ centralRegulatorId: string }>());
export const LoadCentralRegulatorLogoSuccess = createAction(
    DocumentActionTypes.LoadCentralRegulatorLogoSuccess,
    props<{ centralRegulatorLogoUrl: SafeResourceUrl; centralRegulatorId: string }>()
);
export const LoadCentralRegulatorLogoFailure = createAction(
    DocumentActionTypes.LoadCentralRegulatorLogoFailure,
    props<{ centralRegulatorId: string; error: any }>()
);

export const LoadCentralRegulatorLogoExtra = createAction(
    DocumentActionTypes.LoadCentralRegulatorLogoExtra,
    props<{ centralRegulatorId: string }>()
);
export const LoadCentralRegulatorLogoExtraSuccess = createAction(
    DocumentActionTypes.LoadCentralRegulatorLogoExtraSuccess,
    props<{ centralRegulatorLogoExtraUrl: SafeResourceUrl; centralRegulatorId: string }>()
);
export const LoadCentralRegulatorLogoExtraFailure = createAction(
    DocumentActionTypes.LoadCentralRegulatorLogoExtraFailure,
    props<{ centralRegulatorId: string; error: any }>()
);

export const UploadCentralRegulatorLogo = createAction(
    DocumentActionTypes.UploadCentralRegulatorLogo,
    props<{ centralRegulatorId: string; file: File }>()
);
export const UploadCentralRegulatorLogoFailure = createAction(
    DocumentActionTypes.UploadCentralRegulatorLogoFailure,
    props<{ error: any }>()
);
export const UploadCentralRegulatorLogoSuccess = createAction(
    DocumentActionTypes.UploadCentralRegulatorLogoSuccess,
    props<{ centralRegulatorLogoUrl: SafeResourceUrl; centralRegulatorId: string }>()
);

export const UploadCentralRegulatorLogoExtra = createAction(
    DocumentActionTypes.UploadCentralRegulatorLogoExtra,
    props<{ centralRegulatorId: string; file: File }>()
);
export const UploadCentralRegulatorLogoExtraFailure = createAction(
    DocumentActionTypes.UploadCentralRegulatorLogoExtraFailure,
    props<{ error: any }>()
);
export const UploadCentralRegulatorLogoExtraSuccess = createAction(
    DocumentActionTypes.UploadCentralRegulatorLogoExtraSuccess,
    props<{ centralRegulatorLogoExtraUrl: SafeResourceUrl; centralRegulatorId: string }>()
);
